export default __webpack_public_path__ + "static/media/bg3.f14bd97e.jpg";